import { render } from "./MainConfigureVouchersPrint.vue?vue&type=template&id=c53900d6&scoped=true"
import script from "./MainConfigureVouchersPrint.vue?vue&type=script&lang=js"
export * from "./MainConfigureVouchersPrint.vue?vue&type=script&lang=js"

import "./MainConfigureVouchersPrint.vue?vue&type=style&index=0&id=c53900d6&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53900d6"]])

export default __exports__